import { Link } from "gatsby"
import React,{ useState } from "react"
import {
  AiOutlineTwitter,
} from "react-icons/ai"
import { FaLinkedinIn } from "react-icons/fa"
import { FaFacebookSquare } from "react-icons/fa"
import { FaMedium } from "react-icons/fa"
import { FaYoutube } from "react-icons/fa"
import { BiChevronRight } from "react-icons/bi"
import Sidebar from "../sidebar"


const Footer = ({ variant, footerData, atlasOneLogo }) => {

  const [clicked, setClicked] = useState(-1)


  const getSrcSet = (src) => {
    const ratioArry = [1, 1.5, 2, 3]
    let srcSet = ""
    const width = 200
    ratioArry.forEach(ratio => srcSet += `${src}?w=${width * ratio} ${ratio}x, `)
    return srcSet
  }
  const handleOpen = id => {
    if (clicked === id) {
      setClicked(-1)
    } else {
      setClicked(id)
    }
  }
  return (
    <div
      className={`w-screen mx-auto h-full md:px-10 xl1:px-40 ${variant === "dark"
          ? "bg-black text-ProjectBlack"
          : "bg-ProjectBlack text-black"
        }`}
    >
      <div className="w-full max-w-screen-xl pb-20 mx-auto ">
        {footerData  && (
          <hr
            className={`mb-10 md:mb-20 opacity-20
              ${variant === "dark" ? "border-ProjectBlack" : "border-black"}
            `}
          />
        )}
        {/* Footer Links */}
        <div className="hidden md:block md:px-5 lg:px-0">
          <ul className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 md:justify-center">
            {footerData?.map((data, index) => (
              <div key={index} className="my-3">
                <li
                  className={`Figtree-Bold font-bold text-base mb-[30px] tracking-widest ${variant === "dark" ? "text-ProjectBlue" : "text-black"
                    } uppercase`}
                >
                  {data.columnTitle}
                </li>
                {data.links?.map((item, idx) => (
                  <li key={idx} className="my-[15px]">
                    <Link
                      to={item.page?.slug ? `/${item.page?.slug}` : `${item.url}`}
                      className=" text-sm Saira-Medium tracking-wide leading-[140%] hover:text-ProjectBlue"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </div>
            ))}
          </ul>
        </div>

        {/* Mobile Version*/}
        <div className="block md:hidden">
          <ul className="flex flex-col items-start justify-start mx-3 font-semibold tracking-wide font-nunito text-primary">
            {footerData?.map((item, index) => (
              <li
                className="w-full mb-10 text-base font-medium uppercase text-ProjectBlack hover:text-ProjectBlue"
                key={index}
                onClick={() => handleOpen(index)}
                role="presentation"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold tracking-widest Figtree-Semibold text-ats text-ProjectBlack">
                      {item.columnTitle}
                    </p>
                  </div>
                  <div>
                    <BiChevronRight fontSize={25} className="text-ProjectBlack" />
                  </div>
                </div>
                {clicked === index && (
                  <Sidebar
                    dropdownData={item.links}
                    sidebarName={item.columnTitle}
                    role="presentation"
                  />
                )}
                <hr className="w-full text-[#FFFFFF26] h-[0.5px] mt-3" />
              </li>
            ))}
          </ul>
        </div>
        {/* Contact */}
        <div
          className={`flex items-start md:items-center justify-between  flex-col md:flex-row px-5 lg:px-0
            ${footerData ? "mt-20" : " mt-10"}
          `}
        >
          <Link to="/">
            {variant === "dark" ? (
              <img
                className="logo"
                srcSet={getSrcSet(atlasOneLogo?.image?.file?.url)}
                alt="Atlas One"
              />
            ) : (
              <img
                className="logo"
                srcSet={getSrcSet(atlasOneLogo?.image?.file?.url)}
                alt="Atlas One"
              />
            )}
          </Link>
          <div className="flex items-center justify-between mt-[35px] md:mt-0 ">
          {/* <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
          <FaFacebookSquare className="mr-5 hover:text-ProjectBlue" fontSize={24} />
            </a> */}
            <a href="https://twitter.com/atlasoneapp" target="_blank" rel="noopener noreferrer">
              <AiOutlineTwitter className="mr-5 hover:text-ProjectBlue" fontSize={24} />
            </a>
            <a href="https://www.linkedin.com/company/atlasoneapp" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn className="mr-5 hover:text-ProjectBlue" fontSize={24} />
            </a>
          {/*<a href="#" target="_blank" rel="noopener noreferrer">
            <FaMedium className="mr-5 hover:text-ProjectBlue" fontSize={24} />
          </a> */}
          {/* <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
            <FaYoutube className="hover:text-ProjectBlue" fontSize={24} />
          </a> */}
          </div>
        </div>
        <hr
          className={`hidden md:block ${variant === "dark" ? "border-ProjectBlack" : "border-black"
            }  mt-10 mb-[30px] opacity-20`}
        />
        {/* Copyright */}
        <div className="flex items-start md:items-center justify-start max-w-[550px] w-full flex-col md:flex-row px-5 lg:px-0">
          <p className="text-xs tracking-wide Saira-Medium mr-[15px] pt-[45px] md:pt-0">
            @ {(new Date().getFullYear())} Atlas One. All right reserved.
          </p>
          <Link
            to="/privacy"
            className="text-xs tracking-wide Saira-Medium mx-0 md:mx-[15px] pt-5 md:pt-0 hover:text-ProjectBlue"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            className="text-xs tracking-wide Saira-Medium mx-0 md:mx-[15px] pt-5 md:pt-0 hover:text-ProjectBlue"
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Footer
